import React, { useState } from "react";
import { Edit2, Trash2, Copy, Eye, ArrowDown, ChevronDown, ChevronUp, Edit, Clock } from "lucide-react";
import { toast } from "react-toastify";
import workflowApi from "../../api/workflowApi";
import { CreateWorkflowTemplateModal } from "../workflowTemplates/CreateWorkflowTemplateModal";
import { TemplatePreviewModal } from "../workflowTemplates/TemplatePreviewModal";
import SearchBar from "../../components/SearchBar";


export const TemplatesTab = ({
    workflowTemplates,
    showActions = false,
    refreshTemplates,
    token
}) => {
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [editTemplate, setEditTemplate] = useState(null);
    const searchFields = ["name"];
    const [filteredTasks, setFilteredTasks] = useState(workflowTemplates);

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this template?")) return;
        try {
            await workflowApi.deleteWorkflowTemplate(id, token);
            toast.success("Template deleted successfully!");
            if (refreshTemplates) refreshTemplates();
        } catch (error) {
            console.error("❌ Error deleting template:", error);
            toast.error("Failed to delete template.");
        }
    };

    const formatText = (text = "") =>
    text
        .toLowerCase()
        .split("_")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");


    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-2">
            {filteredTasks?.length !== 0 ?
            <div className="flex flex-row items-center justify-between py-1">
                <h3 className="text-lg font-semibold text-gray-900 w-[50%]">
                    Workflow Templates
                </h3>
                <div className="flex item-end justify-end w-[50%]">
                        <SearchBar
                            data={workflowTemplates}
                            searchFields={searchFields}
                            onSearchResults={setFilteredTasks}
                            placeholder="Search tasks by title, description..."
                        />
                </div>
            </div> : <></>}
            {filteredTasks?.length !== 0 ?
            <div className="grid grid-cols-1 gap-1">
                {filteredTasks.map((template) => {
                const isSelected = selectedTemplate?.id === template.id;
                return (
                    <div
                        key={template.id}
                        onClick={() => setSelectedTemplate(isSelected ? null : template)}
                        className={`cursor-pointer border border-gray-200 rounded-lg p-2 
              hover:shadow-md transition-shadow ${isSelected ? "bg-blue-100" : "bg-white"} h-full`}
                    >
                        <div className="flex flex-row items-center justify-between">
                            <div className="">
                                <h4 className="font-medium text-base text-gray-900 break-words mb-1">
                                    {formatText(template.name)}
                                </h4>


                                <p className="text-sm text-gray-600 mb-1">
                                    {template.tasksLength || template.tasks?.length || 0} predefined tasks
                                </p>
                            </div>


                            <div className="">
                                <button
                                    className="p-2 text-slate-700 rounded-full transition"
                                    title="Toggle Preview"
                                >
                                    {isSelected ? (
                                        <ChevronUp size={16} />
                                    ) : (
                                        <ChevronDown size={16} />
                                    )}
                                </button>

                                {showActions && (
                                    <>
                                        <button
                                            onClick={() => setEditTemplate(template)}
                                            className="p-0.5 text-blue-600 rounded-full transition"
                                            title="Edit"
                                        >
                                            <Edit size={16} />
                                        </button>
                                        <button
                                            onClick={() => handleDelete(template.id)}
                                            className="p-0.5 text-red-600 rounded-full transition"
                                            title="Delete"
                                        >
                                            <Trash2 size={16} />
                                        </button>
                                    </>
                                )}
                            </div>
                        </div>
                        {selectedTemplate?.id === template.id &&
                        <div>
                            <TemplatePreviewModal
                                template={selectedTemplate}
                                onClose={() => setSelectedTemplate(null)}
                            />
                        </div>} 
                    </div>
                )})}
            </div>:<></>}
            {filteredTasks?.length !== 0 ? <></> :
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 text-center">
              <Clock className="h-12 w-12 text-gray-400 mx-auto mb-1" />
              <h4 className="text-lg font-medium text-gray-900 mb-1">No Templates</h4>
              <p className="text-gray-600 mb-4">
                No Templates have been assigned for this Workflow Templates yet.
              </p>
            </div>}

            {/* {selectedTemplate && (
                <TemplatePreviewModal
                    template={selectedTemplate}
                    onClose={() => setSelectedTemplate(null)}
                />
            )} */}

            {editTemplate && (
                <CreateWorkflowTemplateModal
                    templateToEdit={editTemplate}
                    onClose={() => setEditTemplate(null)}
                    refreshTemplates={refreshTemplates}
                    token={token}
                    isEditMode={true}
                />
            )}
        </div>
    );
};
